export const chatQueryKeys = {
  conversation: ["chat", "conversation"] as const
} as const;
